import {
  teamworkItems,
  teamworkCreate
} from '@/api/teamwork'

const teamwork = {
  state: {

  },
  mutations: {

  },
  actions: {
    TeamworkItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        teamworkItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    TeamworkCreate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        teamworkCreate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default teamwork



// WEBPACK FOOTER //
// ./src/store/modules/teamwork.js